<template>
  <div class="home-pop-container">
    <van-popup v-model="show" position="left" style="height: 100%; left: unset">
      <div class="content">
        <div
          v-clipboard:copy="userInfo.address"
          v-clipboard:success="onCopy"
          class="no-box"
        >
          <div class="no">
            <img src="../../assets/copy.svg" alt="" />
            <div class="text">
              {{ userInfo.address }}
            </div>
          </div>
        </div>
        <div class="user-info">
          <div class="user-info-left">
            <img :src="configInfo.site_logo" alt="" />
          </div>
          <div class="user-info-right">
            <div class="user-info-right-top">
              {{ $t("welcome") }}<span>{{ configInfo.site_name }}</span>
            </div>
            <div class="user-info-right-bot">
              <div class="user-id">ID：{{ userInfo.id }}</div>
              <div class="score">
                {{ $t("home_tip_score") }}: {{ userInfo.credit_score }}
              </div>
              <div class="vip" v-if="showVIP == 'true'">
                {{ $t('grade') }}: <span>VIP{{ userInfo.vip_level }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="operation-bar">
          <div
            class="operation-bar-item"
            @click="goMessage"
          >
            <div class="operation-bar-item-left">
              <van-icon name="comment" size="20"  color="#bfccd5" />{{
                $t("message_center")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div
            class="operation-bar-item"
            v-if="configInfo.is_rebate"
            @click="goPromotion"
          >
            <div class="operation-bar-item-left">
              <img src="../../assets/promote.png" alt="" />{{
                $t("promotion_center")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div
            class="operation-bar-item"
            v-if="configInfo.is_rebate"
            @click="goShare"
          >
            <div class="operation-bar-item-left">
              <img src="../../assets/share.png" alt="" />{{
                $t("sidebar_share")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div class="operation-bar-item" @click="goSetPwd" v-if="isNeedPassword == 'need'">
            <!-- sidebar_changePassword 修改 -->
            <div class="operation-bar-item-left">
              <img src="../../assets/set-pwd.png" alt="" />{{
                userInfo.fund_password
                  ? $t("sidebar_changePassword")
                  : $t("sidebar_bindPassword")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <!-- <div class="operation-bar-item" @click="goSetLoginPwd">
            <div class="operation-bar-item-left">
              <img src="../../assets/set-login-pwd.png" alt="" />{{
                userInfo.login_password
                  ? $t("sidebar_changeLoginPassword")
                  : $t("sidebar_setLoginPassword")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div class="operation-bar-item" @click="goBindEmail">
            <div class="operation-bar-item-left">
              <img src="../../assets/email.png" alt="" />{{
                $t("coinbase_hs_tit3")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div> -->
          <div class="operation-bar-item" @click="goServiceUrl">
            <div class="operation-bar-item-left">
              <img src="../../assets/contact.png" alt="" />{{
                $t("tokpiedex_home_service")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div class="operation-bar-item" @click="goService">
            <div class="operation-bar-item-left">
              <img src="../../assets/service.png" alt="" />{{
                $t("coinbase_hs_tit1")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
          <div class="operation-bar-item" @click="openWhitePaper" v-if="hideWitePaper !== 'true'">
            <div class="operation-bar-item-left">
              <img src="../../assets/white-paper.png" alt="" />{{
                $t("coinbase_hs_tit2")
              }}
            </div>
            <div class="operation-bar-item-right">
              <img src="../../assets/arrow-right-black.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    serviceUrl: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      userInfo: "",
      configInfo: "",
      showVIP: false,
      isNeedPassword: '',
      whitePaper:'https://s0.static777.top/whitepaper_defi-ETH.pdf',
      hideWitePaper : '',
    };
  },
  created() {
    this.getConfig();
  },
  async mounted() {
    await this.$onLaunched;
    await this.getUserInfo();
    this.showVIP = process.env.VUE_APP_SHOW_VIP
    this.isNeedPassword = process.env.VUE_APP_WITHDRAW_PASS
    this.hideWitePaper = process.env.VUE_APP_HIDE_WHITE_PAPER
    if(process.env.VUE_APP_WHITE_PAPER){
      this.whitePaper = process.env.VUE_APP_WHITE_PAPER
    }
  },
  methods: {
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
      }
    },
    async getConfig() {
      const res = await this.$api.getConfig();
      if (res.code == 200) {
        this.configInfo = res.data;
      }
    },
    goServiceUrl() {
      // window.location.href = this.serviceUrl
      this.$emit("showService");
    },
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    goPromotion() {
      this.$router.replace("/promotion-center");
    },
    goShare() {
      this.$router.replace("/share");
    },
    goSetPwd() {
      this.$router.replace("/set-pass");
    },
    goSetLoginPwd() {
      this.$router.replace("/set-login-pass");
    },
    goBindEmail() {
      this.$router.replace("/bind-email");
    },
    goService() {
      this.$router.replace("/terms-service");
    },
    openWhitePaper() {
      window.open(this.whitePaper);
    },
    goMessage() {
      this.$router.push('/message-center')
    }
  },
};
</script>

<style lang="scss" scoped>
.home-pop-container {
  .content {
    padding: 20px 15px;
    box-sizing: border-box;
    .no-box {
      display: flex;
      justify-content: flex-end;
      .no {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background: #f4f4f4;
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 14px;
        width: 100px;
        .text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .user-info {
      display: flex;
      align-items: center;
      margin-top: 20px;
      &-left {
        img {
          width: 50px;
          height: 50px;
        }
      }
      &-right {
        margin-left: 10px;
        &-top {
          span {
            color: #0f59f5;
            margin-left: 5px;
          }
        }
        &-bot {
          font-size: 14px;
          color: #7d919d;
          margin-top: 10px;
          .vip {
            span {
              color: #0f59f5;
            }
          }
        }
      }
    }
    .operation-bar {
      margin-top: 30px;
      height: calc(100vh - 300px);
      overflow: scroll;
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        padding-left: 15px;
        padding-right: 10px;
        &-left {
          display: flex;
          align-items: center;
          font-size: 16px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          .van-icon-comment {
            margin-right: 10px;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px;
            height: 27px;
          }
        }
      }
    }
  }
}
@media (min-width: 640px) {
  .home-pop-container {
    .content {
      padding: 20px 15px;
      box-sizing: border-box;
      .no-box {
        display: flex;
        justify-content: flex-end;
        .no {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          background: #f4f4f4;
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 14px;
          width: 100px;
          .text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
      .user-info {
        display: flex;
        align-items: center;
        margin-top: 20px;
        &-left {
          img {
            width: 50px;
            height: 50px;
          }
        }
        &-right {
          margin-left: 10px;
          &-top {
            span {
              color: #0f59f5;
              margin-left: 5px;
            }
          }
          &-bot {
            font-size: 14px;
            color: #7d919d;
            margin-top: 15px;
          }
        }
      }
      .operation-bar {
        margin-top: 30px;
        height: calc(100vh - 300px);
        overflow: scroll;
        overflow-x: hidden;
        overflow-y: hidden;
        &-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          padding-left: 15px;
          padding-right: 10px;
          &-left {
            display: flex;
            align-items: center;
            font-size: 16px;
            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
          &-right {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 20px;
              height: 27px;
            }
          }
        }
      }
    }
  }
}
</style>